_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
PluginView = require 'app/scripts/views/plugin/plugin-view'

module.exports = class PluginButtonsView extends PluginView
  buttonsSelector: '.js-button-list'
  buttonView: null

  initialize: ->
    @requestButtonsDebounced = _.debounce =>
      @requestButtons()
    , 500

  hideContainer: (pluginButtons) ->
    !pluginButtons? || pluginButtons.length == 0

  renderContainer: ->
    @$el

  runnerOptions: ->
    throw Error('runnerOptions not specified')

  renderButtons: (pluginButtons) ->
    $target = @renderContainer(pluginButtons)
    @$el.toggleClass('hide', @hideContainer(pluginButtons))
    @removeSubviews()

    subviews = _.sortBy(pluginButtons, 'text').map (pluginButton, index) =>
      if pluginButton.view?
        return @subview pluginButton.view, @model, {}, index

      @subview @buttonView, @model, { pluginButton }, index
    @appendSubviews subviews, $target

  requestButtons: ->
    PluginRunner.all @runnerOptions()
    .then (pluginButtons) =>
      # filter buttons down based on condition prop
      pluginButtons = _.filter pluginButtons, (pluginButton) =>
        # drop anything that doesn't appear to be a button object
        if _.isArray(pluginButton) || !_.isObject(pluginButton) || !pluginButton?.text
          return false

        if !pluginButton.condition?
          return @model.editable()

        switch pluginButton.condition
          when 'admin'
            if @model.typeName == 'Card'
              @model.getBoard().owned()
            else if @model.typeName == 'Board'
              @model.owned()
            else
              false
          when 'edit' then @model.editable()
          when 'readOnly' then !@model.editable()
          when 'signedIn' then Auth.isLoggedIn()
          when 'signedOut' then !Auth.isLoggedIn()
          when 'always' then true
          else false # unknown condition

      @renderButtons(pluginButtons)
    .catch ->
      console?.warn('Failed to request Power-Up buttons.')

  vigor: @VIGOR.NONE
  renderOnce: ->
    options = @runnerOptions()

    @subscribe pluginsChangedSignal(options.board, options.card), @requestButtonsDebounced

    @
